var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm.isLoggedIn ? _c("Menu") : _vm._e(),
      _c(
        "div",
        { staticClass: "pages-container" },
        [
          _vm.isLoading ? _c("Loading") : _vm._e(),
          _vm.showConfirm ? _c("Confirm") : _vm._e(),
          _c("Notification"),
          _c("router-view")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }